const LIST_MARKER = /^\s*(?:[-–—•*]|\d+[.)])\s+/

export function parsePastedList (text) {
  const parts = text.includes('\n') ? text.split(/\r?\n/) : text.split(/[;,]/)

  return parts.map((part) => part.replace(LIST_MARKER, '').trim()).filter(Boolean)
}
